import { Globe, Hash, MessageSquare, type LucideIcon } from 'lucide-react';

export interface ChannelInfo {
  icon: LucideIcon;
  label: string;
}

/*
 * The places a conversation can happen. A channel we do not know yet is
 * still shown — under its own name, rather than dropped — so a channel added to
 * the backend appears here before anyone touches this file.
 */
const CHANNELS: Record<string, ChannelInfo> = {
  web: { icon: Globe, label: 'Web' },
  msteams: { icon: MessageSquare, label: 'Teams' },
  slack: { icon: Hash, label: 'Slack' },
};

export function channelInfo(channel: string): ChannelInfo {
  return CHANNELS[channel] ?? { icon: MessageSquare, label: channel };
}
